const ITEMS = [
  "Liver Specialist",
  "Endoscopy & Colonoscopy",
  "DM Gastroenterology — IMS BHU",
  "Acidity · IBS · Fatty Liver Care",
  "Lanka · Sunderpur · BHU · Varanasi",
  "Trusted across Purvanchal",
  "Mon–Sun · 9 AM – 5 PM",
  "Call +91 93696 98080",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span
        key={item}
        className="flex items-center whitespace-nowrap font-heading text-sm sm:text-base font-medium tracking-wide text-navy/70"
      >
        <span className="px-6">{item}</span>
        <span className="h-1.5 w-1.5 rounded-full bg-sky-500/70" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-slate-200 bg-white py-4"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
